export default "__VITE_ASSET__CwOjU0MT__"